export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-stone-100 py-20 px-4 mt-40">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-light text-gray-900 mb-6">
            PRIVACY POLICY
          </h1>
          <div className="w-24 h-px bg-gray-300 mx-auto"></div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-12 font-['Montserrat']">
          {/* Introduction */}
          <section>
            <p className="text-gray-700 leading-relaxed">
              PRV Creative is committed to protecting the privacy of your personal data. This privacy policy explains how we collect, use, share, and protect your information when you use our website and photography services.
            </p>
          </section>

          {/* Section 1 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              1. Information We Collect
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <h3 className="font-medium text-gray-900 mt-6">1.1 Information You Provide to Us</h3>
              <p>
                When you use our website or services, we may collect the following information:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>First and last name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Event date and location</li>
                <li>Photography project details</li>
                <li>Budget and preferences</li>
                <li>Any other information you choose to share with us</li>
              </ul>

              <h3 className="font-medium text-gray-900 mt-6">1.2 Automatically Collected Information</h3>
              <p>
                When you visit our website, we automatically collect certain technical information:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Pages visited and visit duration</li>
                <li>Approximate location data</li>
                <li>Cookies and similar technologies</li>
              </ul>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              2. How We Use Your Information
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>We use your personal information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respond to your inquiries and booking requests</li>
                <li>Provide our professional photography services</li>
                <li>Communicate with you regarding your project</li>
                <li>Improve our website and services</li>
                <li>Send you marketing information (with your consent)</li>
                <li>Comply with our legal obligations</li>
                <li>Protect our rights and prevent fraud</li>
              </ul>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              3. Sharing Your Information
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We never sell your personal data. We may share your information only in the following cases:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Service Providers:</strong> We work with trusted partners who help us operate our website and provide our services (hosting, payment, etc.)</li>
                <li><strong>Legal Obligations:</strong> If required by law or to protect our legal rights</li>
                <li><strong>With Your Consent:</strong> In other cases, only with your explicit authorization</li>
              </ul>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              4. Cookies and Tracking Technologies
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Our website uses cookies and similar technologies to improve your experience. Cookies are small text files stored on your device.
              </p>
              <h3 className="font-medium text-gray-900 mt-6">Types of Cookies Used:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Essential Cookies:</strong> Necessary for the website to function</li>
                <li><strong>Performance Cookies:</strong> To analyze website usage</li>
                <li><strong>Functionality Cookies:</strong> To remember your preferences</li>
                <li><strong>Marketing Cookies:</strong> To personalize content (with your consent)</li>
              </ul>
              <p className="mt-4">
                You can manage your cookie preferences through your browser settings.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              5. Data Security
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We take the security of your data very seriously and implement appropriate technical and organizational measures to protect your personal information against unauthorized access, loss, destruction, or alteration.
              </p>
              <p>
                However, no method of transmission over the Internet or electronic storage is completely secure. While we strive to protect your data, we cannot guarantee absolute security.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              6. Your Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                In accordance with the General Data Protection Regulation (GDPR), you have the following rights:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Right of Access:</strong> Obtain a copy of your personal data</li>
                <li><strong>Right to Rectification:</strong> Correct inaccurate or incomplete data</li>
                <li><strong>Right to Erasure:</strong> Request deletion of your data</li>
                <li><strong>Right to Restriction:</strong> Limit the processing of your data</li>
                <li><strong>Right to Portability:</strong> Receive your data in a structured format</li>
                <li><strong>Right to Object:</strong> Object to the processing of your data</li>
                <li><strong>Right to Withdraw Consent:</strong> At any time</li>
              </ul>
              <p className="mt-4">
                To exercise these rights, please contact us at: <a href="mailto:contact@example.com" className="text-gray-900 underline hover:text-gray-700">contact@example.com</a>
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              7. Data Retention
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We retain your personal data only for as long as necessary for the purposes for which it was collected, or in accordance with legal obligations.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact data: Up to 3 years after your last interaction</li>
                <li>Contractual data: Legal retention period (generally 10 years)</li>
                <li>Marketing data: Until withdrawal of your consent</li>
              </ul>
            </div>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              8. Photographs and Image Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                The photographs we create may contain your image or that of your guests. The use of these images is governed by a separate contract that specifies:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Usage rights for the photographs</li>
                <li>Authorization for publication in our portfolio</li>
                <li>Conditions for sharing on social media</li>
                <li>Protection of your privacy</li>
              </ul>
              <p className="mt-4">
                We never publish photographs without your explicit authorization.
              </p>
            </div>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              9. Links to Third-Party Sites
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Our website may contain links to third-party sites. We are not responsible for the privacy practices of these sites. We encourage you to read their privacy policies.
              </p>
            </div>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              10. Changes to This Policy
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We may update this privacy policy from time to time. The date of the last update is indicated at the top of this page. We encourage you to review this page regularly to stay informed of our practices.
              </p>
              <p>
                In case of significant changes, we will notify you by email or through a notice on our website.
              </p>
            </div>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
              11. Contact
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                For any questions regarding this privacy policy or to exercise your rights, you can contact us:
              </p>
              <div className="bg-stone-50 p-6 rounded-lg mt-6 space-y-3">
                <p><strong>PRV Creative</strong></p>
                <p>Based in France</p>
                <p>Email: <a href="mailto:contact@example.com" className="text-gray-900 underline hover:text-gray-700">contact@example.com</a></p>
                <p>Phone: <a href="tel:+33749239472" className="text-gray-900 underline hover:text-gray-700">+33 (7) 49 23 94 72</a></p>
              </div>
              <p className="mt-6">
                You also have the right to file a complaint with the National Commission for Information Technology and Civil Liberties (CNIL) if you believe your rights are not being respected.
              </p>
            </div>
          </section>

          {/* Consent Section */}
          <section className="border-t border-gray-200 pt-12">
            <div className="bg-stone-50 p-8 rounded-lg">
              <h2 className="font-['Cormorant_Garamond'] text-3xl font-light text-gray-900 mb-4">
                Consent
              </h2>
              <p className="text-gray-700 leading-relaxed">
                By using our website and services, you acknowledge that you have read and understood this privacy policy and consent to the collection, use, and sharing of your information as described in this document.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
